/// <reference types="google.maps" />
import { GOOGLE_MAPS_API_KEY } from "../../config";

// Helpful alias for the global google namespace type
type GoogleNS = typeof google;

let _promise: Promise<GoogleNS> | null = null;

export const GoogleMapsLoader = {
  /**
   * Loads Google Maps JS once.
   * - Default language: "ar"
   * - Default region:   "SA"
   * Subsequent calls return the same promise (language/region cannot be changed after first load).
   */
  load(language: string = "ar", region: string = "SA"): Promise<GoogleNS> {
    if (_promise) return _promise;

    const key = GOOGLE_MAPS_API_KEY;
    if (!key) {
      return Promise.reject(new Error("Missing GOOGLE_MAPS_API_KEY in config.ts"));
    }

    _promise = new Promise<GoogleNS>((resolve, reject) => {
      const w = window as any;

      // Already present (HMR or previously loaded)
      if (w.google?.maps) {
        resolve(w.google as GoogleNS);
        return;
      }

      const cbName = "__gmapsInit__" + Math.random().toString(36).slice(2);
      w[cbName] = () => {
        resolve(w.google as GoogleNS);
        try { delete w[cbName]; } catch {}
      };

      const params = new URLSearchParams({
        key,
        callback: cbName,
        v: "weekly",
        loading: "async",
        language,         // force Arabic UI by default
        region            // bias services (geocoder, tiles) to KSA by default
      });

      const s = document.createElement("script");
      s.async = true;
      s.defer = true;
      s.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
      s.onerror = () => reject(new Error("Failed to load Google Maps JS"));
      document.head.appendChild(s);
    });

    return _promise;
  }
};
